class Search {
  constructor() {
    this.btnSearch = document.querySelector('.header__btn-search');
    this.btnClose = document.querySelector('.header__form-search__btn-close');
    this.formContainer = document.querySelector('.header__form-search');

    this.init();
  }

  toggle() {
    if (this.formContainer.classList.contains('js--active')) {
      this.formContainer.classList.remove('js--active');
    } else {
      this.formContainer.classList.add('js--active');
    }
  }

  init() {
    this.btnSearch.addEventListener('click', () => this.toggle());
    this.btnClose.addEventListener('click', () => this.toggle());
  }
}

export default Search;
